import account from './account'
import address from './address'
import load from './load'
import branding from './branding'
import currencies from './currencies'
import carManage from './carManage'
import company from './company'
import companyExtra from './companyExtra'
import dashboard from './dashboard'
import fileManager from './fileManager'
import forms from './forms'
import featur from './featur'
import feedback from './feedback'
import geolocations from './geolocations'
import items from './items'
import menus from './menus'
import nav from './nav'
import pages from './pages'
import roles from './roles'
import shared from './shared'
import systemManage from './systmManage'
import security from './security'
import users from './users'
import unit from './unit'
import userGroup from './userGroup'
import widgetAreas from './widgetAreas'
import websiteShipment from './websiteShipment'
import tariff from './tariff'
import webservice from './webservice'
import message from './message'
import urlShortened from './urlShortened'
import financial from './financial'
import giftCard from './giftCard'
import couponTypes from './couponTypes'
import validation from './validation'
import policy from './policy'
import promotions from './promotions'
import campaign from './campaign'
import crm from './crm'
import cms from './cms'
import questionnaire from './questionnaire'
import jsonEditor from './jsonEditor'
import formulaMaker from './formulaMaker'
import timeSheet from './timeSheet'
import meta from './meta'
import blog from './blog'
import map from './map'
import commercialBanking from './commercial-banking'
import toast from './toast'
import billOfLading from './bill-of-lading.js'

// refactored
import shipment from './shipment'
import log from './log'
import chart from './chart'
import constants from './constants'

// baraneh
import baraneh from './baraneh'
import editorType from './editorType'
import credential from './credential'

export default {
  direction: 'rtl',
  account,
  address,
  load,
  branding,
  currencies,
  carManage,
  company,
  companyExtra,
  dashboard,
  fileManager,
  forms,
  featur,
  feedback,
  geolocations,
  items,
  menus,
  nav,
  pages,
  roles,
  shared,
  systemManage,
  security,
  users,
  unit,
  userGroup,
  widgetAreas,
  websiteShipment,
  tariff,
  webservice,
  message,
  urlShortened,
  financial,
  giftCard,
  couponTypes,
  validation,
  policy,
  promotions,
  campaign,
  crm,
  cms,
  questionnaire,
  jsonEditor,
  formulaMaker,
  timeSheet,
  meta,
  blog,
  map,

  //refactored
  shipment,
  log,
  chart,
  constants,
  commercialBanking,
  toast,
  baraneh,
  editorType,
  credential,
  billOfLading
}
